import type { ScreenAppearanceKey, ScreenBrandColors, StyledButtonConfig } from '@/types/form.types'
import { DEFAULT_BUTTON_CONFIGS, normalizeStyledButtonConfig } from '@/utils/buttonStyles'

export const DEFAULT_GOOGLE_FONT = 'Montserrat'

export const DEFAULT_SCREEN_BRAND_COLORS: Record<ScreenAppearanceKey, ScreenBrandColors> = {
  registration: {
    primary: '#7ae6b1',
    background: '#292e50',
    header: '#181b2f',
    secondary: '#7ae6b1',
    buttonText: '#ffffff',
  },
  interaction: {
    primary: '#7ae6b1',
    background: '#292e50',
    header: '#181b2f',
    secondary: '#7ae6b1',
    buttonText: '#ffffff',
  },
  prize: {
    primary: '#7ae6b1',
    background: '#292e50',
    header: '#181b2f',
    secondary: '#7ae6b1',
    buttonText: '#ffffff',
  },
}

const SCREEN_BRAND_COLOR_KEYS: Array<keyof ScreenBrandColors> = [
  'primary',
  'background',
  'header',
  'secondary',
  'buttonText',
]

const normalizeColorValue = (value?: string | null) => value?.trim().toUpperCase() || ''

export const isScreenBrandColorsCustomized = (
  screen: ScreenAppearanceKey,
  colors: ScreenBrandColors,
) => {
  const defaults = DEFAULT_SCREEN_BRAND_COLORS[screen]
  return SCREEN_BRAND_COLOR_KEYS.some((key) => normalizeColorValue(colors[key]) !== normalizeColorValue(defaults[key]))
}

export const isGoogleFontCustomized = (value?: string | null) =>
  (value?.trim() || DEFAULT_GOOGLE_FONT) !== DEFAULT_GOOGLE_FONT

export const isButtonConfigCustomized = (
  screen: ScreenAppearanceKey,
  value?: StyledButtonConfig | null,
) => {
  const current = normalizeStyledButtonConfig(value, DEFAULT_BUTTON_CONFIGS[screen])
  const defaults = normalizeStyledButtonConfig(DEFAULT_BUTTON_CONFIGS[screen], DEFAULT_BUTTON_CONFIGS[screen])

  return (
    current.label !== defaults.label ||
    current.url !== defaults.url ||
    current.target !== defaults.target ||
    current.textColor !== defaults.textColor ||
    current.backgroundColor !== defaults.backgroundColor ||
    current.borderColor !== defaults.borderColor ||
    current.borderRadius !== defaults.borderRadius ||
    current.blurPx !== defaults.blurPx ||
    current.styleVariant !== defaults.styleVariant ||
    JSON.stringify(current.dropShadow) !== JSON.stringify(defaults.dropShadow)
  )
}
